import { Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';
import { SpreadingRowLinkService } from './spreading-row-link.service';

/**
 * Applied to each Data Categorization table's scroll wrapper. Uses a single
 * delegated `mouseover` listener (rows carry `data-row-key`) so hovering a row
 * highlights the matching row in the other table. Listeners are bound outside
 * Angular and only toggle a CSS class, so hovering never triggers change
 * detection on the grid.
 */
@Directive({
  selector: '[appRowLinkHover]',
  standalone: false,
})
export class RowLinkHoverDirective implements OnDestroy {
  constructor(
    private el: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    private rowLinkService: SpreadingRowLinkService
  ) {
    this.ngZone.runOutsideAngular(() => {
      const host = this.el.nativeElement;
      host.addEventListener('mouseover', this._onMouseOver);
      host.addEventListener('mouseleave', this._onMouseLeave);
    });
  }

  ngOnDestroy(): void {
    const host = this.el.nativeElement;
    host.removeEventListener('mouseover', this._onMouseOver);
    host.removeEventListener('mouseleave', this._onMouseLeave);
    this.rowLinkService.setHoveredKey(null);
  }

  private readonly _onMouseOver = (event: MouseEvent): void => {
    const target = event.target as HTMLElement | null;
    const rowEl = target?.closest<HTMLElement>('[data-row-key]') ?? null;
    this.rowLinkService.setHoveredKey(rowEl?.getAttribute('data-row-key') ?? null);
  };

  private readonly _onMouseLeave = (): void => {
    this.rowLinkService.setHoveredKey(null);
  };
}
